<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Шаги</p>
      <div class="mb-4">
        <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
      </div>
      <div>
        <div class="table-container mb-16 js-table-arrow">
          <table class="stockTable">
            <thead>
              <tr>
                <th></th>
                <th>Шаг</th>
                <th>Операция</th>
                <th>Статус</th>
                <th>Дата создания</th>
                <th>Дата изменения</th>
              </tr>
              <tr>
                <th class="filter"></th>
                <th class="filter">
                  <FilterInput
                    v-model="filter.action"
                    placeholder="Найти..."
                    v-on:valueChangedDebounced="changeFilter"
                  />
                </th>
                <th class="filter">
                  <FilterInput v-model="filter.step" placeholder="Найти..." v-on:valueChangedDebounced="changeFilter" />
                </th>
                <th class="filter">
                  <FilterActiveInput
                    v-model="filter.isActive"
                    placeholder="(Все)"
                    v-on:valueChangedDebounced="changeFilter"
                  />
                </th>
                <th class="filter date-w-135">
                  <FilterInput
                    type="date"
                    modClass="filter-small"
                    v-model="filter.createdStart"
                    v-on:valueChangedDebounced="changeFilter"
                    :upperLimit="upperLimitCreationStart"
                    dateIcon
                  />
                  <FilterInput
                    type="date"
                    modClass="filter-small"
                    v-model="filter.createdEnd"
                    v-on:valueChangedDebounced="changeFilter"
                    :upperLimit="upperLimitEnd"
                    :lowerLimit="lowerLimitCreationEnd"
                    dateIcon
                  />
                </th>
                <th class="filter date-w-135">
                  <FilterInput
                    type="date"
                    modClass="filter-small"
                    v-model="filter.modifiedStart"
                    v-on:valueChangedDebounced="changeFilter"
                    :upperLimit="upperLimitModifiedStart"
                    dateIcon
                  />
                  <FilterInput
                    type="date"
                    modClass="filter-small"
                    v-model="filter.modifiedEnd"
                    v-on:valueChangedDebounced="changeFilter"
                    :upperLimit="upperLimitEnd"
                    :lowerLimit="lowerLimitModifiedEnd"
                    dateIcon
                  />
                </th>
              </tr>
            </thead>
            <tbody v-if="page.items?.length && !isLoading">
              <tr v-for="item in page.items" :key="item.id" @dblclick="editCard(item.stepId)">
                <td>
                  <IconComponent @click="editCard(item.stepId)" name="mode" />
                </td>
                <td>{{ item.action }}</td>
                <td>{{ item.stepName }}</td>
                <td>{{ item.isActive ? 'действ.' : 'не действ.' }}</td>
                <td class="table-sort__td column-date-creation">
                  <p>{{ $momentFormat(item.created, DATE_FORMATS['DD.MM.YYYY HH:mm']) }}</p>
                </td>
                <td class="table-sort__td column-date-change">
                  <p>{{ $momentFormat(item.modified, DATE_FORMATS['DD.MM.YYYY HH:mm']) }}</p>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isLoading">
              <tr>
                <td class="text-center" colspan="6">Загрузка...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-center" colspan="6">Нет данных.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="page.pagesTotal > 1">
          <Pagination
            :pageCount="page.pagesTotal"
            :currentPage="page.pageNumber"
            @change="onPageChange($event, false)"
            @more="onPageChange($event, true)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterActiveInput from '@/common/components/FilterActiveInput.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import Constants from '@/common/constants';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import API from '../api/stepActions';
  import dateFormat from '../mixin/dateFormat.js';

  export default {
    name: 'StepActions',
    components: { FilterInput, FilterActiveInput, DefaultFilter, IconComponent },
    mixins: [dateFormat],
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        isLoading: false,
        filter: {
          action: '',
          createdStart: '',
          createdEnd: '',
          modifiedStart: '',
          modifiedEnd: '',
        },
        DATE_FORMATS: Constants.DATE_FORMATS,
      };
    },
    created() {
      loadFilter(this.$options.name).then((response) => {
        let filter = response;
        if (filter) {
          this.filter = filter;
        }
        this.loadPage();
      });
    },
    methods: {
      loadPage(append) {
        this.isLoading = true;
        const request = Object.assign(this.filter, this.request);
        API.search(request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error?.response?.data);
          });
      },
      editCard(id) {
        this.$router.push({ name: 'StepCard', params: { id: id, action: 'edit' } });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
    },
  };
</script>

<style scoped>
  .stockTable {
    min-height: 65vh;
  }
</style>
